module.exports = __webpack_public_path__ + "static/media/3 05 Tulleord Falk er riktig.019009cc.mp3";